module.exports = __webpack_public_path__ + "img/lottery-btn.4eb66853.png";